// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Slide container */
.banner-slide {
  position: relative;
  width: 100%;
  height: 450px;
  overflow: hidden;
}

/* Image fit */
.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;       /* ✅ Perfect fit */
  object-position: center;
  filter: brightness(65%);
  transition: transform 6s ease;
}

/* Smooth zoom effect */
.banner-slide:hover .banner-img {
  transform: scale(1.05);
}

/* Overlay */
.banner-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  width: 80%;
}

/* Title */
.banner-overlay h2 {
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 10px;
}

/* Subtitle */
.banner-overlay p {
  font-size: 1.2rem;
  opacity: 0.9;
}

/* 📱 Tablet */
@media (max-width: 992px) {
  .banner-slide {
    height: 350px;
  }

  .banner-overlay h2 {
    font-size: 2rem;
  }

  .banner-overlay p {
    font-size: 1rem;
  }
}

/* 📱 Mobile */
@media (max-width: 576px) {
  .banner-slide {
    height: 220px;
  }

  .banner-overlay {
    width: 90%;
  }

  .banner-overlay h2 {
    font-size: 1.3rem;
  }

  .banner-overlay p {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/banner.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,QAAQ,kBAAkB;EAC3C,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,cAAc;AACd;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Slide container */\r\n.banner-slide {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 450px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Image fit */\r\n.banner-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;       /* ✅ Perfect fit */\r\n  object-position: center;\r\n  filter: brightness(65%);\r\n  transition: transform 6s ease;\r\n}\r\n\r\n/* Smooth zoom effect */\r\n.banner-slide:hover .banner-img {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* Overlay */\r\n.banner-overlay {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  color: #fff;\r\n  text-align: center;\r\n  width: 80%;\r\n}\r\n\r\n/* Title */\r\n.banner-overlay h2 {\r\n  font-weight: 700;\r\n  font-size: 2.5rem;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Subtitle */\r\n.banner-overlay p {\r\n  font-size: 1.2rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n/* 📱 Tablet */\r\n@media (max-width: 992px) {\r\n  .banner-slide {\r\n    height: 350px;\r\n  }\r\n\r\n  .banner-overlay h2 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .banner-overlay p {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n/* 📱 Mobile */\r\n@media (max-width: 576px) {\r\n  .banner-slide {\r\n    height: 220px;\r\n  }\r\n\r\n  .banner-overlay {\r\n    width: 90%;\r\n  }\r\n\r\n  .banner-overlay h2 {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .banner-overlay p {\r\n    font-size: 0.85rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
